// https://vuetmp.vuejs.org/en/mutations.html

export default {
  setQuestionsAnswered: ({ questions }) => {
    questions.pagination.filterBy = 'answered';
  },
  setQuestionsLoading: ({ questions }) => {
    questions.loading = true;
  },
  loadQuestionsSuccess: ({ questions }, payload) => {
    questions.items = payload.data;
    questions.pagination.totalItems = payload.recordsTotal;
    questions.numUnanswered = payload.numUnanswered;
    questions.numAnswered = payload.numAnswered;
    questions.loading = false;
  },
  setQuestionsPagination({ questions }, payload) {
    questions.pagination.descending = payload.descending;
    questions.pagination.page = payload.page;
    questions.pagination.rowsPerPage = payload.rowsPerPage;
    questions.pagination.sortBy = payload.sortBy;
    questions.pagination.totalItems = payload.totalItems;
    questions.pagination.filterBy = payload.filterBy;
  },
  setQuestionForm({ questionForm }, payload) {
    questionForm.id = payload.id;
    questionForm.userName = payload.userName;
    questionForm.userEmail = payload.userEmail;
    questionForm.timestamp = payload.timestamp;
    questionForm.questionText = payload.questionText;
    questionForm.answerText = payload.answerText;
    questionForm.posted = payload.posted;
    questionForm.answered = payload.answered;
  },
};
